import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=50ce2bb6&scoped=true&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/article.css?vue&type=style&index=0&id=50ce2bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce2bb6",
  null
  
)

export default component.exports